import { render, staticRenderFns } from "./p_company009.vue?vue&type=template&id=36e1e3d8&scoped=true&"
import script from "./p_company009.vue?vue&type=script&lang=js&"
export * from "./p_company009.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1e3d8",
  null
  
)

export default component.exports